import React from 'react';
import classNames from 'classnames';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';

import styles from './typeahead-overlay.scss';

interface CloseButtonProps {
  isTypeaheadOpen: boolean;
  onCloseButtonClick: () => void;
  onTabOut?: () => void;
}

export const CloseButton = ({
  isTypeaheadOpen,
  onCloseButtonClick,
  onTabOut = () => {},
}: CloseButtonProps) => {
  const closeButtonClasses = classNames([styles.bpCloseButton], {
    [styles.bpCloseButton__hidden]: !isTypeaheadOpen,
  });

  return (
    <button
      data-testid={`close-expanded-search`}
      className={closeButtonClasses}
      onClick={onCloseButtonClick}
      onBlur={onTabOut}
      aria-label="Close search"
    >
      <CloseOutlined className={styles.closeIcon} size="medium" />
    </button>
  );
};
